<template>
    <view_app
        class="view_app"
        v-bind:class="{
            single_application_solution:
                App.root_activated_view == 'single_application_solution'
        }"
    ></view_app>
</template>

<script>
import $ from 'jquery'
import view_app from './components/view_app.vue'
import App from './application.js'

export default {
    name: 'UnexApp',

    components: {
        view_app
    },

    data: function () {
        return {
            App: App,
            current_category_filter_selected: '',
            app_title: 'Vue Dashboard',
            // root_activated_view: 'dashboard',
            current_query: {},
            token: '',
            is_debug_mode: false,
            is_clean_filters: true,
            current_query_name: '',
            is_admin: sessionStorage.is_admin,
            lateral_menu_items: App.lateral_menu_items
        }
    },
    watch: {
        // TODO: WTF?
        root_activated_view: function (value) {
            App.setLanguage(
                App.selected_language_solutions
            );
            if (value === 'single_application_solution' && App.active_view !== 'single_application_solution') {
                $(document).off("keydown");
                $(document).on("keydown", function (e) {
                    e = e || window.event;
                    if (e.keyCode == '37' && !App.loading_activated && !document.movingSlider) {
                        App.bus.$emit('prev_solution_image', e);
                    }
                    else if (e.keyCode == '39' && !App.loading_activated && !document.movingSlider) {
                        App.bus.$emit('next_solution_image', e);
                    }
                });
            }
            if (App.active_view === 'single_application_solution' && value !== 'single_application_solution') {
                document.onkeydown = null;
            }

            App.bus.$emit(
                'change_menu_items',
                App.filterInCurrentView(this.lateral_menu_items, value)
            );
            App.active_view = value;
        }
    },
    mounted: function () {
        var self = this;

        App.bus.$on('hide_loader', (function (who) {
            setTimeout((function () {
                self.preload_total_items++;
                if (self.preload_total_items == self.preload_total_preloading_items) {
                    $('#loading_wrapper').hide();
                    if (typeof self.preload_onload == "function") {
                        self.preload_onload();
                        self.preload_onload = null;
                    }
                    self.preload_total_items = 0;
                    self.preload_total_preloading_items = 0;
                }
            }).bind(this), 50);
        }));

        App.bus.$on('show_loader', function (items, onload) {
            $('#loading_wrapper').show();
            self.preload_total_preloading_items = items;
            self.preload_total_items = 0;
            self.preload_onload = onload;
        });
    }
}
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}

/* Arreglar imatges verticals */

.slider-solutions-images {
    height: 100% !important;
}
.slider-solutions-images .slick-slider{
    height: 100% !important;
}
.slider-solutions-images .slick-list{
    height: 100% !important;
}
.slider-solutions-images .slick-track{
    height: 100% !important;
}
.slider-solutions-images .slick-slide{
    height: 100% !important;
}
.slider-solutions-images .slick-slide > div{
    height: 100% !important;
    text-align: center !important;
}
.slider-solutions-images .slick-slide > div > img{
    max-height: 100% !important;
    max-width: 100% !important;
    width: auto !important;
}
</style>
